//@ts-nocheck
import React from "react";
import {
  withStyles,
  Typography,
  createStyles,
  Button,
} from "@material-ui/core";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";

export class PackageDetail extends React.Component {
  closeDialog = (data) => {
    const { onSubmit } = this.props;
    onSubmit(data);
  };

  render() {
    const { classes } = this.props;
    const logo = this.props.dataToPass?.logo;
    const IconComponent = typeof logo !== "string" ? logo : null;

    return (
      <div className={classes.root}>
        <div className={classes.iconBox}>
          {IconComponent
            ? <IconComponent size={47} className={classes.icon} />
            : <img className={classes.image} src={logo} alt={this.props.dataToPass?.name} />}
        </div>
        <div className={classes.content}>
          <Typography className={classes.name}>
            {this.props.dataToPass?.name}
          </Typography>
          <Typography className={classes.description}>
            {this.props.dataToPass?.description}
          </Typography>
          <div className={classes.selectRow}>
            <div className={classes.priceRow}>
              <Typography className={classes.priceAmount}>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                  roundingMode: "ceil",
                }).format(this.props.dataToPass?.price || 0)}
              </Typography>
              <Typography className={classes.perUnit}>per unit</Typography>
            </div>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={() => this.closeDialog(this.props.dataToPass.package)}
              style={{ width: 75, height: 34, fontSize: 12, borderRadius: 4 }}
            >
              Select
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const PackageDetailWithRouter = withRouter(PackageDetail);
const PackageDetailWithToast = withToast(PackageDetailWithRouter);
const PackageDetailWithLoader = withLoader(PackageDetailWithToast);
const PackageDetailWithAlertBox = withAlertBox(PackageDetailWithLoader);

export default withStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      gap: 24,
      alignItems: "flex-start",
      padding: "12px 20px",
      width: "100%",
      boxSizing: "border-box",
    },
    iconBox: {
      width: 110,
      height: 110,
      flexShrink: 0,
      backgroundColor: "#f3f7f7",
      borderRadius: 12,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
    },
    image: {
      width: 47,
      height: 47,
      objectFit: "contain",
      opacity: 0.7,
    },
    icon: {
      color: theme.palette.primary.main,
      opacity: 0.7,
    },
    content: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: 6,
      minWidth: 0,
    },
    name: {
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.primary.main,
      lineHeight: 1.4,
      margin: 0,
    },
    description: {
      fontSize: 12,
      fontWeight: 400,
      color: "#666",
      lineHeight: "normal",
      margin: 0,
    },
    selectRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: 4,
    },
    priceRow: {
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
    priceAmount: {
      fontSize: 19,
      fontWeight: 600,
      color: theme.palette.primary.main,
      lineHeight: 1,
    },
    perUnit: {
      fontSize: 14,
      fontWeight: 400,
      color: "#666",
      lineHeight: 1.4,
    },
  })
)(PackageDetailWithAlertBox);
